// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__lK3yC","contentWrapper":"styles_contentWrapper__HztDR","content":"styles_content__X08bU"};